import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const NAV_LINKS = [
  { label: "Home", id: "star-container" },
  { label: "Skills", id: "section-skills" },
  { label: "About", id: "section-about" },
  { label: "Journey", id: "section-journey" },
  { label: "Work", id: "section-work" },
];

const Header = () => {
  const [active, setActive] = useState("star-container");
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/";

  const handleNavClick = (id) => {
    if (isHome) {
      // Already on home — just scroll
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // On another page — go home and jump to section
      navigate(`/#${id}`);
    }
  };

  // After navigating to home with a hash, scroll to the section
  useEffect(() => {
    if (isHome && location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        // Small delay to let the page render first
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 100);
      }
    }
  }, [location,isHome]);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);

      const current = NAV_LINKS.map(({ id }) => {
        const el = document.getElementById(id);
        if (!el) return null;
        return { id, top: el.getBoundingClientRect().top };
      })
        .filter(Boolean)
        .filter((s) => s.top <= 100)
        .at(-1);

      if (current) setActive(current.id);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 40px",
        height: "56px",
        background: scrolled ? "rgba(5, 6, 15, 0.82)" : "rgba(5, 6, 15, 0.4)",
        borderBottom: "0.5px solid rgba(255,255,255,0.08)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        transition: "background 0.3s",
      }}>
      {/* Logo */}
      <button
        onClick={() => handleNavClick("star-container")}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          fontFamily: "DM Mono, monospace",
          fontSize: "13px",
          fontWeight: "500",
          color: "#d8ecf8",
          letterSpacing: "0.02em",
          flexShrink: 0,
        }}>
        Jason Azevedo
      </button>

      {/* Nav links */}
      <nav style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {NAV_LINKS.map(({ label, id }) => (
          <button
            key={id}
            onClick={() => handleNavClick(id)}
            style={{
              fontFamily: "DM Mono, monospace",
              fontSize: "11px",
              fontWeight: "400",
              // Only show active state when on home page
              color: isHome && active === id ? "#d8ecf8" : "rgba(216,236,248,0.55)",
              background: isHome && active === id ? "rgba(152,192,239,0.12)" : "none",
              border: isHome && active === id ? "1px solid rgba(152,192,239,0.5)" : "1px solid transparent",
              padding: "6px 12px",
              borderRadius: "90px",
              cursor: "pointer",
              transition: "color 0.2s, border-color 0.2s, background 0.2s",
            }}>
            {label}
          </button>
        ))}
        {/* Resume tab */}
        <a
          href="/resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            fontFamily: "DM Mono, monospace",
            fontSize: "11px",
            fontWeight: "400",
            color: "rgba(216,236,248,0.55)",
            background: "none",
            border: "1px solid transparent",
            padding: "6px 12px",
            borderRadius: "90px",
            cursor: "pointer",
            textDecoration: "none",
            transition: "color 0.2s, border-color 0.2s, background 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = "#d8ecf8";
            e.currentTarget.style.background = "rgba(152,192,239,0.12)";
            e.currentTarget.style.borderColor = "rgba(152,192,239,0.5)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = "rgba(216,236,248,0.55)";
            e.currentTarget.style.background = "none";
            e.currentTarget.style.borderColor = "transparent";
          }}>
          Resume ↗
        </a>
      </nav>

      {/* CTA */}
      <a
        href="mailto:jazeveedo17@gmail.com"
        style={{
          fontFamily: "DM Mono, monospace",
          fontSize: "11px",
          fontWeight: "500",
          color: "#0b1117",
          background: "#98c0ef",
          border: "none",
          padding: "7px 16px",
          borderRadius: "90px",
          cursor: "pointer",
          textDecoration: "none",
          transition: "opacity 0.2s",
          flexShrink: 0,
          display: "inline-block",
        }}
        onMouseEnter={(e) => (e.target.style.opacity = "0.85")}
        onMouseLeave={(e) => (e.target.style.opacity = "1")}>
        Let&apos;s talk ↗
      </a>
    </header>
  );
};

export default Header;
